/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContractOrderFromJSON, ContractOrderToJSON, } from './ContractOrder';
/**
 * Check if a given object implements the OrderExternalCollaboratorOutputDto interface.
 */
export function instanceOfOrderExternalCollaboratorOutputDto(value) {
    return true;
}
export function OrderExternalCollaboratorOutputDtoFromJSON(json) {
    return OrderExternalCollaboratorOutputDtoFromJSONTyped(json, false);
}
export function OrderExternalCollaboratorOutputDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'contractOrder': json['contractOrder'] == null ? undefined : ContractOrderFromJSON(json['contractOrder']),
        'fkOrdine': json['fkOrdine'] == null ? undefined : json['fkOrdine'],
        'idUtenteIntranet': json['idUtenteIntranet'] == null ? undefined : json['idUtenteIntranet'],
        'tariffa': json['tariffa'] == null ? undefined : json['tariffa'],
        'numGiornate': json['numGiornate'] == null ? undefined : json['numGiornate'],
        'aggu': json['aggu'] == null ? undefined : json['aggu'],
        'acosti': json['acosti'] == null ? undefined : json['acosti'],
    };
}
export function OrderExternalCollaboratorOutputDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'contractOrder': ContractOrderToJSON(value['contractOrder']),
        'fkOrdine': value['fkOrdine'],
        'idUtenteIntranet': value['idUtenteIntranet'],
        'tariffa': value['tariffa'],
        'numGiornate': value['numGiornate'],
        'aggu': value['aggu'],
        'acosti': value['acosti'],
    };
}
